import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'locales/i18n';

import { router } from 'routes';
import { ANTD_CONFIG } from 'config/antd';
import { initGA } from 'services/tracking/gaTracking';
import 'styles/global.scss';
import 'react-tooltip/dist/react-tooltip.css';

initGA();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false // default: true
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={ANTD_CONFIG}>
        <RouterProvider router={router} />
      </ConfigProvider>
    </QueryClientProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
